import { render, staticRenderFns } from "./MiniPlayer.vue?vue&type=template&id=870992d2&scoped=true&"
import script from "./MiniPlayer.vue?vue&type=script&lang=js&"
export * from "./MiniPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MiniPlayer.vue?vue&type=style&index=0&id=870992d2&prod&scoped=true&lang=css&"
import style1 from "./MiniPlayer.vue?vue&type=style&index=1&id=870992d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870992d2",
  null
  
)

export default component.exports